module.exports = __webpack_public_path__ + "static/media/chatbot.de243c16.jpg";